<div class="block">
    <div class="heading">Add your profile photo</div>
<div class="info">
  <p>Help clients recognise you.</p>
</div>

    <div class="actions">
        <button class="discard-button" (click)="onSkip()">Skip</button>
        <button class="primary-btn" (click)="onUpload()">Upload photo</button>
    </div>
</div>
